import {createSelector} from 'reselect';
import differenceInDays from 'date-fns/differenceInDays';
import {getTripData} from './store';

// Returns number of nights between arrive/depart dates
const getTripNights = createSelector(
    [getTripData],
    (tripData) => {
        const {arriveDateText, departDateText} = tripData;

        return differenceInDays(new Date(departDateText), new Date(arriveDateText)) || 0;
    }
);

export {getTripNights};
